import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { useBesluitId } from '@/api/queries/besluit/besluit';

import { fetchHoofdstukkenInEditorQueryData } from './-utils/useHoofdstukkenInEditor';

const searchSchema = z.object({
  type: z.enum(['first-hoofdstuk']),
});

export const Route = createFileRoute(
  '/$bedrijfLineageId/editor/$besluitId/redirect'
)({
  validateSearch: searchSchema.parse,
  beforeLoad: async ({
    context: { queryClient },
    params: { besluitId, bedrijfLineageId },
    search,
  }) => {
    const besluit = await queryClient.fetchQuery(
      useBesluitId.getOptions(besluitId)
    );

    if (!besluit) throw notFound();

    if (search.type === 'first-hoofdstuk') {
      const grondslagen = await fetchHoofdstukkenInEditorQueryData({
        besluitId,
        queryClient,
      });
      const firstHoofdstuk = grondslagen[0]?.hoofdstukken[0];

      /**
       * If there's a first hoofdstuk, redirect to it
       */
      if (firstHoofdstuk) {
        throw redirect({
          to: '/$bedrijfLineageId/editor/$besluitId/voorschriften/$hoofdstukLineageId',
          params: {
            bedrijfLineageId,
            besluitId,
            hoofdstukLineageId: firstHoofdstuk.Lineage,
          },
        });
      } else {
        throw redirect({
          to: '/$bedrijfLineageId/editor/$besluitId/voorschriften/hoofdstuk',
          params: {
            bedrijfLineageId,
            besluitId,
          },
        });
      }
    }
  },
});
